import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import PhoneForm from "./components/PhoneForm";
import SmsForm from "./components/SmsForm";
import Booking from "./components/Booking";
import Booked from "./components/Booked";

function AppContent() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState(
    () => sessionStorage.getItem("phone") || ""
  );
  const [schedule, setSchedule] = useState(() => {
    const saved = sessionStorage.getItem("schedule");
    return saved ? JSON.parse(saved) : null;
  });
  const [needsSmsAuth, setNeedsSmsAuth] = useState(() => {
    return sessionStorage.getItem("needsSmsAuth") === "true";
  });
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem("isAuthenticated") === "true";
  });

  const handlePhoneSubmit = (submittedPhone, response) => {
    setPhone(submittedPhone);
    setSchedule(response.schedule || []);
    setNeedsSmsAuth(response.smsauth || false);

    sessionStorage.setItem("phone", submittedPhone);
    sessionStorage.setItem("schedule", JSON.stringify(response.schedule || []));
    sessionStorage.setItem("needsSmsAuth", response.smsauth || false);

    if (response.smsauth) {
      // Нужна SMS авторизация
      navigate("/sms");
    } else {
      // Можно сразу перейти к бронированию
      setIsAuthenticated(true);
      sessionStorage.setItem("isAuthenticated", "true");
      navigate("/booking");
    }
  };

  const handleAuthSuccess = () => {
    setIsAuthenticated(true);
    sessionStorage.setItem("isAuthenticated", "true");
    navigate("/booking");
  };

  const handleScheduleUpdate = (newSchedule) => {
    setSchedule(newSchedule);
    sessionStorage.setItem("schedule", JSON.stringify(newSchedule || []));
  };

  return (
    <Routes>
      <Route
        path="/"
        element={<PhoneForm onPhoneSubmit={handlePhoneSubmit} />}
      />
      <Route
        path="/sms"
        element={
          phone && needsSmsAuth ? (
            <SmsForm phone={phone} onAuthSuccess={handleAuthSuccess} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/booking"
        element={
          schedule && phone && (isAuthenticated || !needsSmsAuth) ? (
            <Booking
              phone={phone}
              schedule={schedule}
              onScheduleUpdate={handleScheduleUpdate}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="/booked" element={<Booked />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
